import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin: 30px 0;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 8px;

  @media(min-width: 960px) {
    width: auto;
    order: 1;
    padding: 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 16px 16px;

  @media(min-width: 960px) {
    justify-content: flex-end;
    width: auto;
    order: 2;
    padding: 0;
  }
`;

export const CipCounter = styled.div`
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.BLACK};
  font-size: 14px;
  line-height: 16px;
  margin-right: 16px;
`;
